/* Choose Your Size — multi-select: a quantity per size, one add-to-cart for all.
   Case-pack pricing per size. The sticky bar is cart-aware: it shows "Add to cart"
   while you have sizes selected, and flips to "Checkout" once items are in the cart. */
(function () {
  'use strict';
  var root = document.getElementById('size-form');
  if (!root) return;
  var cards = [].slice.call(root.querySelectorAll('[data-size-card]'));
  var totalEls = document.querySelectorAll('[data-total]');
  var sticky = document.querySelector('[data-size-sticky]');
  var stickyPrice = document.querySelector('[data-sticky-price]');
  var stickyLabel = document.querySelector('[data-sticky-label]');
  var stickyAction = document.querySelector('[data-sticky-action]');
  var addBtns = [].slice.call(root.querySelectorAll('[data-size-add]')); // inline CTA only
  var fmt = (window.KoiCart && window.KoiCart.format) || function (c) { return '$' + (c / 100).toFixed(2); };
  var reduce = (window.Koi && window.Koi.reduceMotion);
  var lastTotal = 0;
  var scrolledPast = false;
  var cartCount = 0, cartTotal = 0;
  if (window.Koi && window.Koi.initialCart) { cartCount = window.Koi.initialCart.item_count || 0; cartTotal = window.Koi.initialCart.total_price || 0; }

  function cardQty(card) { var v = parseInt(card.querySelector('[data-card-qty-val]').textContent, 10); return isNaN(v) ? 0 : v; }
  function cardTotal(card) {
    var q = cardQty(card); if (q <= 0) return 0;
    var unit = parseInt(card.getAttribute('data-price'), 10);
    var addl = parseInt(card.getAttribute('data-addl'), 10) || unit;
    return unit + (q - 1) * addl; // case-pack pricing
  }
  function totalCents() { return cards.reduce(function (s, c) { return s + cardTotal(c); }, 0); }
  function totalBags() { return cards.reduce(function (s, c) { return s + cardQty(c); }, 0); }

  function countUp(el, to) {
    if (reduce || !window.gsap) { el.textContent = fmt(to); return; }
    var o = { v: lastTotal };
    window.gsap.to(o, { v: to, duration: 0.4, ease: 'power2.out', onUpdate: function () { el.textContent = fmt(o.v); } });
  }

  function update() {
    var total = totalCents();
    var none = totalBags() === 0;
    totalEls.forEach(function (el) { if (none) { el.textContent = ''; } else { countUp(el, total); } });
    document.querySelectorAll('.kg-size__dot').forEach(function (d) { d.style.display = none ? 'none' : ''; });
    addBtns.forEach(function (b) { b.toggleAttribute('disabled', none); });
    lastTotal = total;

    // Cart-aware sticky bar
    if (sticky) {
      if (!none) { // sizes selected → add mode
        if (stickyLabel) stickyLabel.textContent = 'Your order';
        if (stickyPrice) stickyPrice.textContent = fmt(total);
        if (stickyAction) { stickyAction.textContent = 'Add to cart'; stickyAction.setAttribute('data-mode', 'add'); stickyAction.disabled = false; }
      } else if (cartCount > 0) { // nothing selected but cart has items → checkout mode
        if (stickyLabel) stickyLabel.textContent = cartCount + (cartCount === 1 ? ' item in cart' : ' items in cart');
        if (stickyPrice) stickyPrice.textContent = fmt(cartTotal);
        if (stickyAction) { stickyAction.textContent = 'Checkout'; stickyAction.setAttribute('data-mode', 'checkout'); stickyAction.disabled = false; }
      } else { // nothing selected, empty cart
        if (stickyLabel) stickyLabel.textContent = 'Your order';
        if (stickyPrice) stickyPrice.textContent = fmt(0);
        if (stickyAction) { stickyAction.textContent = 'Add to cart'; stickyAction.setAttribute('data-mode', 'add'); stickyAction.disabled = true; }
      }
    }
    refreshSticky();
  }

  // Show the sticky bar only when there's something to act on (selection or a non-empty cart),
  // and flag <body> so the footer can leave room for it.
  function refreshSticky() {
    if (!sticky) return;
    var show = scrolledPast && (totalBags() > 0 || cartCount > 0);
    sticky.classList.toggle('is-show', show);
    document.body.classList.toggle('kg-has-sticky', show);
  }

  function setCardQty(card, q) {
    q = Math.max(0, Math.min(99, q));
    card.querySelector('[data-card-qty-val]').textContent = q;
    card.classList.toggle('is-active', q > 0);
    update();
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-card-qty]');
    if (!btn || btn.disabled) return;
    var card = btn.closest('[data-size-card]');
    setCardQty(card, cardQty(card) + parseInt(btn.getAttribute('data-card-qty'), 10));
  });

  function addToCart() {
    var items = cards.filter(function (c) { return cardQty(c) > 0; })
      .map(function (c) { return { id: c.getAttribute('data-variant-id'), quantity: cardQty(c) }; });
    if (!items.length || !window.KoiCart) return;
    addBtns.forEach(function (b) { b.disabled = true; });
    if (stickyAction) stickyAction.disabled = true;
    window.KoiCart.add(items).then(function () {
      // reset selections so the bar flips to "Checkout" and we never double-add
      cards.forEach(function (c) { c.querySelector('[data-card-qty-val]').textContent = '0'; c.classList.remove('is-active'); });
    }).finally(update);
  }
  addBtns.forEach(function (b) { b.addEventListener('click', addToCart); });

  if (stickyAction) {
    stickyAction.addEventListener('click', function () {
      if (stickyAction.getAttribute('data-mode') === 'checkout') window.location.href = '/checkout';
      else addToCart();
    });
  }

  // Stay in sync with the cart drawer (add / remove / qty changes).
  document.addEventListener('koi:cart', function (e) {
    if (!e.detail) return;
    cartCount = e.detail.item_count || 0;
    cartTotal = e.detail.total_price || 0;
    update();
  });

  // Feeding-guide hook: ensure a recommended size is in the order.
  window.KoiSize = {
    addBag: function (variantId) {
      var card = cards.filter(function (c) { return c.getAttribute('data-variant-id') == variantId; })[0];
      if (card) setCardQty(card, Math.max(1, cardQty(card)));
    }
  };

  update();

  var inlineCta = root.querySelector('.kg-size__cta');
  if (sticky && inlineCta && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    var io = new IntersectionObserver(function (entries) {
      var en = entries[0];
      scrolledPast = !en.isIntersecting && en.boundingClientRect.top < 0;
      refreshSticky();
    }, { threshold: 0 });
    io.observe(inlineCta);
  }
})();
